module.exports = osjs;


//////////////////
// WEBPACK FOOTER
// external "osjs"
// module id = Aoin
// module chunks = 0